<template>
    <div>
        <div class="w" id="content">
            <div class="s_tl">
                当前位置：<a href="/">首页</a>
                <em class="lr3">&#62;</em>
                <a href="/help">帮助中心</a>
                <em class="lr3">&#62;</em>
                <a href="">新手上路</a>
                <em class="lr3">&#62;</em>
                <a href="">正品保证</a>
            </div>
            <div class="ubg">
                <left-side></left-side>
                <!--left over-->
                <div class="u_r">
                    <div class="ah1 alC yahei">
                        <h1 class="f18">正品保证</h1>
                        <p class="c9">发布时间：2022-01-04</p>
                    </div>
                    <div class="ainfo ov yahei">
                        <p>
                            <img alt="" height="300" width="800" src="https://s.cccgx.com/images/upload/Image/zpbz.jpg">
                        </p>
                        <p><br></p>
                        <h2>
                            <span style="font-size:20px;color:#E53333;">一、夜樱情趣承诺：全场正品</span>
                        </h2>
                        <p>
                            <span>
                                夜樱情趣所有出售的商品均来源于知名品牌，为各品牌授权的正规渠道产品，所有商品的原盒包装、吊牌（部分商品官方无吊牌）、条码及其附件均与专卖店无异，对于现在消费者对网上销售商品的疑虑，我们完全可以理解，因此夜樱情趣特别承诺：<span style="color:#4C33E5;text-decoration:underline;">假一赔三，免除您的后顾之忧，请您放心购买！</span>
                            </span>
                        </p>
                        <h2>
                            <span style="font-size:20px;color:#E53333;">
                                二、如何确保正品？
                            </span>
                        </h2>
                        <p>
                            <strong>
                                <span style="font-size:18px;color:#4C33E5;">
                                    1、完善的供应链：
                                </span>
                            </strong>
                            <span>
                                夜樱情趣管理层拥有数年的成人用品研发及管理经验，对产品品质的把关能力强，且拥有一支敏锐的采购队伍，为夜樱情趣提供了一条完善的供应链体系，也为您所购买的商品构筑了第一道保障。
                            </span>
                        </p>
                        <p>
                            <strong>
                                <span style="font-size:18px;color:#4C33E5;">
                                    2、正规采购渠道：
                                </span>
                            </strong>
                            <span>
                                夜樱情趣所售商品均来源于品牌公司正规渠道，即各品牌公司或经销商直接供货，保证正品，绝不会出现鱼目混杂的情况。
                            </span>
                        </p>
                        <p>
                            <strong>
                                <span style="font-size:18px;color:#4C33E5;">
                                    3、入仓全检保障：
                                </span>
                            </strong>
                            <span>
                                夜樱情趣每一个仓库均设置了品检流水线，对每一件通过正规渠道采购到的商品，由专业的品检员进行全面、严格的检查，无论是国内生产的百乐，或是日本出品的日暮里，只有通过正品“认证”，才能进入夜樱情趣的良品区，有机会销售到顾客朋友的手中。
                            </span> 
                        </p>
                        <p>
                            <strong>
                                <span style="font-size:18px;color:#4C33E5;">
                                    4、质量安全认证：
                                </span>
                            </strong>
                            <span>
                                夜樱情趣销售的产品是通过质量认证的，敬请放心购买使用！
                            </span>
                        </p>
                        
                        <h2>部分授权证书：</h2>
                        <p>
                            <br><br>
                            <img src="../../assets/image/shouquan.jpg" width="750" height="505" alt="">
                        </p>
                        <p><br></p>
                        <h2>
                            <span style="font-size:20px;color:#E53333;">
                                三、如何进行正品验证？
                            </span>
                        </h2>
                        <p>收到产品后，产品包装上有防伪验证，也可以联系我们出示各种认证、授权证书。<br></p>
                        <p><br></p>
                    </div>
                    <!--info over-->
                    <p class="lh30"></p>
                    <p class="bline" style="padding: 30px 0px 0 0;"></p>
                    <p class="lh30"></p>
                    <p style="font-size:16px;">
                        <a href="/help/yinsibaohu" style="float:left;">上一篇:隐私保护</a>
                        <a href="/help/ceomail" class="pl10" style="float:right">下一篇:CEO邮箱</a>
                    </p>
                </div>
                <!--right over-->
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Left_side from "@/components/help/left-side"
export default {
    components:{
        'left-side': Left_side
    },
}
</script>

<style scoped>
.ainfo {line-height: 32px;padding-top: 10px;font-size: 14px;}
.font16{font-size: 16px;}
.ubg{border:1px solid #e5e5e5;background-color:#fff;overflow:hidden;}
.u_l{width:170px;padding:10px;background:#fff;border-right:1px solid #e5e5e5;}
.u_r{padding:10px 40px 30px 40px;border-left:1px solid #e5e5e5;line-height:25px;background:#fff;margin-left:190px;min-height:600px;overflow: hidden;}
.dsl{display:inline;font-weight:normal;}
.udl{margin:0 5px 15px 5px;}
.udl dt{border-bottom:1px solid #e5e5e5;line-height:40px;display:block;font-size:14px;color:#333;font-weight:bold;margin-bottom:10px;}
.udl dd{line-height:30px;text-indent:15px;}
.udl a{display:block;color:#777;margin-bottom:1px;}
.udl a:hover,.udl a.on{color:#c40000;text-decoration:none; background-color:#e5e1e1;}
.article{width:100%;}
.article li{border-bottom:1px dashed #ddd;display:block;width:100%;font-size:14px;line-height:45px;}
.article a{display:block;width:100%;overflow:hidden;}
.article a:hover{color:#c40000;}
.ah1{color:#333;line-height:30px;padding-bottom:10px;border-bottom:2px solid #ddd;}
.a_goods a{width:220px;height:280px;display:inline;float:left;margin:10px 6px;line-height:18px;white-space:nowrap;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/components/help/zhengpinbaozheng.vue